import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingSection, LandingParagraph} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['remuneration', 'common']});

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t(
					'acpsfaq_text_Qdoesdeezerpayartistsorlabels_standalone-web',
					{},
				),
				answer: [
					t('acpsfaq_text_Adoesdeezerpayartistsorlabels_standalone-web'),
				],
			},
			{
				title: t('acpsfaq_text_Qhowdoesdeezerpaysartists_standalone-web'),
				answer: [t('acpsfaq_text_Ahowdoesdeezerpaysartists_standalone-web')],
			},
			{
				title: t(
					'acpsfaq_text_Qhowmuchdoesdeezerpayartists_standalone-web',
					{},
				),
				answer: [t('acpsfaq_text_Ahowmuchdoesdeezerpayartists_standalone-web')],
			},
			{
				title: t(
					'acpsfaq_text_Qdoesdeezerpayartistsperstream_standalone-web',
					{},
				),
				answer: [
					t('acpsfaq_text_Adoesdeezerpayartistsperstream_standalone-web'),
				],
			},
		],
		[t],
	);
	return (
		<LandingSection isContained>
			<LandingSeoFaq articles={articles}>
				<LandingParagraph
					color="text.neutral.primary.default"
					textAlign="center"
					pb={20}
					maxWidth="100%"
				>
					{t(
						'acpslandingpage_text_toreadmoreinfofollowlinksbelow_standalone-web',
					)}
				</LandingParagraph>
			</LandingSeoFaq>
		</LandingSection>
	);
};
